<script>
import { formatPrettyDateTime } from '@utils/data/date-time'

import toggle from '@utils/design/toggle-info'

export default {
  props: {
    cachedCycleEvent: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    deviceEventsDuration: function() {
      return this.cachedCycleEvent.deviceEvents.map((de) => de.duration)
    },

    averageDeviceEventsDuration: function() {
      let average = (array) => {
        return array.reduce((a, b) => a + b || 0) / array.length
      }

      return (average([...this.deviceEventsDuration]) / 60).toFixed(1)
    },

    medianDeviceEventsDuration: function() {
      let mean = (numbers) => {
        let total = 0
        let i
        for (i = 0; i < numbers.length; i += 1) {
          total += numbers[i] || 0
        }
        return total / numbers.length
      }

      let median = (numbers) => {
        // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
        let median = 0
        let numsLen = numbers.length
        numbers.sort()

        if (
          numsLen % 2 ===
          0 // is even
        ) {
          // average of two middle numbers
          median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2
        } else {
          // is odd
          // middle number only
          median = numbers[(numsLen - 1) / 2]
        }

        return median
      }

      return (median([...this.deviceEventsDuration]) / 60).toFixed(1)
    },

    firstDeviceEvent: function() {
      return this.cachedCycleEvent.deviceEvents[
        this.cachedCycleEvent.deviceEvents.length - 1
      ]
    },
  },

  methods: {
    datePretty: function(date) {
      return formatPrettyDateTime(date)
    },
  },
}
</script>

<template>
  <b-card-body
    class="animated fadeIn card card-body cycle-card m-0 clearfix  pb-3 pl-3 pr-3"
  >
    <b-row>
      <b-col md="4">
        <span class="text-uppercase font-weight-bold text-muted clearfix">
          Start
        </span>
        <span class="text-uppercase font-weight-bold ">
          {{ datePretty(cachedCycleEvent.cycleEvent) }}
        </span>
      </b-col>
      <b-col>
        <BaseAnyChartSpark :chart-data="deviceEventsDuration" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4" class="pt-2">
        <span class="text-uppercase font-weight-bold text-muted clearfix">
          Count
        </span>
        <span
          :class="
            firstDeviceEvent.cycle.count == firstDeviceEvent.cycle.total
              ? 'text-success'
              : 'text-danger'
          "
          class="text-uppercase font-weight-bold"
        >
          {{ firstDeviceEvent.cycle.count }}
          <span class="text-uppercase font-weight-bold text-muted clearfix">
            / {{ firstDeviceEvent.cycle.total }}</span
          >
        </span>
      </b-col>
      <b-col md="" class="pt-2">
        <span class="text-uppercase font-weight-bold text-muted clearfix">
          Forecast minutes
        </span>
        <span class="text-uppercase font-weight-bold ">
          {{ firstDeviceEvent.cycle.forecastDurationMinutes.toFixed(1) }}
        </span>
      </b-col>
      <b-col md="" class="pt-2">
        <span class="text-uppercase font-weight-bold text-muted clearfix">
          Med / Avg minutes
        </span>
        <span class="text-uppercase font-weight-bold ">
          {{ medianDeviceEventsDuration === 'NaN' ? '-- ' : medianDeviceEventsDuration }}
          <span class=" text-muted"> / </span>
          {{
            averageDeviceEventsDuration === 'NaN' ? '-- ' : averageDeviceEventsDuration
          }}
        </span>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<style>
.cycle-card {
  border-top: none;
  border-radius: 0;
}
</style>
